import React, { Component } from 'react'; // eslint-disable-line no-unused-vars

class BackgroundColorMobile extends Component {
  
  constructor(props){
    super(props);
    this.body = document.querySelector('body');
  }

  componentDidMount() {
    this.changeBackgroundColorOnMobile();
    window.addEventListener('resize', this.changeBackgroundColorOnMobile, false);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.changeBackgroundColorOnMobile, false);
    this.body.removeAttribute('style');
  }

  changeBackgroundColorOnMobile = () => {
    const screenWidth = document.documentElement.clientWidth;
    if (screenWidth < 1024) {
      this.body.style.background = '#F5F5F5';
    } else {
      this.body.style.background = '#FFF';
    }
  };

  render () {
    return (null)
  }

}

export default BackgroundColorMobile;



// WEBPACK FOOTER //
// ./src/components/BackgroundColorMobile/BackgroundColorMobile.js